import * as types from './action-types';

const initialState = {
    disclosures: {},
    isFetching: false,
    error: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case types.FETCH_DISCLOSURES:
            return {
                ...state,
                isFetching: true,
                error: null
            };

        case types.FETCH_DISCLOSURES_SUCCESS:
            return {
                ...state,
                isFetching: false,
                disclosures: action.payload,
                error: null
            };

        case types.FETCH_DISCLOSURES_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.error
            };

        default:
            return state;
    }
}
